<template>
    <div class="checkbox-input-wrapper">
        <label class="checkbox-container flex items-center mb-2" :class="{ 'checkbox-disabled': !enabled }">
            <input 
                type="checkbox" 
                :id="id" 
                v-model="internalValue" 
                :disabled="!enabled" 
                :required="field.required"
                class="checkbox-native w-5 h-5 mr-2 border border-[var(--bone)] focus:border-[var(--primary)]" 
                :class="{ 'input-error': display_errors && error }"
                @change="$emit('update:value', internalValue); $emit('validate')"
                :aria-invalid="display_errors && error ? 'true' : 'false'" 
                :aria-describedby="errorId" 
            />
            <span class="checkbox-label text-base text-[var(--tone-gray)]" v-if="field.label">{{ field.label }}</span>
        </label>
        <div v-if="display_errors && error" class="error-message flex items-center text-sm text-[var(--error)]" :id="errorId">
            <svg class="max-w-full mr-2 w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            {{ error }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        field: { type: Object, required: true },
        value: { type: Boolean, default: false },
        enabled: { type: Boolean, default: true },
        display_errors: { type: Boolean, default: false },
        error: { type: String, default: '' },
        idSuffix: { type: String, default: '' }
    },
    computed: {
        id() { return `field-${this.field.id}${this.idSuffix}`; },
        errorId() { return `error-field-${this.field.id}${this.idSuffix}`; },
        internalValue: {
            get() { return this.value; },
            set(newValue) { this.$emit('update:value', newValue); }
        }
    }
};
</script>
